<div class="container">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row">
        <div class="col-24">
            <h1>{{pageTitle}}</h1>

        </div>
    </div>
    <div class="row">
        <div class="col-24" *ngIf="!isFormValid">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages" role="alert"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
        <div class="col-24" *ngIf="successOrErrorMessage">
            <div class="alert success">
                {{successOrErrorMessage}}
            </div>
        </div>
        <div class="col-24" *ngIf="ifWarnings">
            <div class="alert warning">
                <p><em>Warning:</em></p>
                <ul>
                    <li *ngFor="let warning of Warnings"><button>{{warning}}</button></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">

            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>
    <fieldset>
        <legend> Information</legend>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Login ID'" [disabled]="disableLogIn"
                        (onValueChange)="userProfiledetail.UserProfileName = $event"
                        [text]="userProfiledetail.UserProfileName" maxlength="20">
                    </ValidatedTextField>
                </div>
            </div>

            <div class="col-8" id="divChangePwd" *ngIf="showChangePwdNavigation">
                <div class="input-wrapper">
                    <a (click)="changePwdNavigation()" class="change-password" tabindex="0" href="javascript:void(0)">Change Password</a>
                </div>
            </div>



            <div class="col-8" *ngIf="isAddMode">
                <div class="input-wrapper">
                    <div>
                        <ValidatedTextField class="field" id="password" label="Password"
                            [text]="userProfiledetail.LoginPassword" type="password"
                            (onValueChange)="userProfiledetail.LoginPassword = $event">
                        </ValidatedTextField>
                        <!--<label>Password</label>
                        <ObfuscatedTextField (onValueChange)="personalDetails.LoginPassword = $event"
                                             fieldId="pwd"
                                             [text]="personalDetails.LoginPassword">
                        </ObfuscatedTextField>-->
                    </div>
                </div>
            </div>
            <div class="col-8" *ngIf="isAddMode">
                <div class="instructions-list">
                    <span><strong>The password must:</strong></span>
                    <ul>
                        <li>Be a minimum length of 12 characters</li>
                        <li>Contain at least 1 upper-case letter</li>
                        <li>Contain at least 1 lower-case letter</li>
                        <li>Contain at least 1 special non-alpha-character</li>
                        <li>Contain at least 1 number</li>
                        <li>No character can occur 3 times consecutively</li>
                        <li>You cannot re-use any of your previous 8 passwords</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row" id="divUserTypeAndOrg" *ngIf="showUserTypeSection">
            <!--<div class="col-8">
                <div class="input-wrapper">
                    <Label for="Organization">Organization</Label>
                    <jq-org-dropdown (onValueChange)="OnOrgSelected($event)" #child></jq-org-dropdown>
                </div>
            </div>-->
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedDropDown class="wide" [label]="'User Type'" [options]="userType"
                        [selectedValue]="userProfiledetail.RoleID" (onValueChange)="OnUserTypeSelected($event)">
                    </ValidatedDropDown>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6" id="divEmpID" *ngIf="displayEmpID">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Employee ID'" [text]="userProfiledetail.UID"
                        (onValueChange)="userProfiledetail.UID = $event" maxlength="7">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </fieldset>
    <div class="row">
        <org-view (orgAdded)="onOrgSelectedFromView($event)" [orgSelected]="orgSelected"
            [hideBrowseView]="isOrgSelectHidden"></org-view>
        <br />
    </div>

    <fieldset>
        <legend>Personal Information</legend>
        <div class="row">
            <div class="col-6">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'First Name'" [text]="userProfiledetail.FirstName"
                        [validators]="[notBlankValidator]" (onValueChange)="userProfiledetail.FirstName = $event"
                        maxlength="50" [disabled]="DisabledName">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Middle Name'" [disabled]="noMiddleName"
                                        [text]="userProfiledetail.MiddleName" [validators]="[notBlankStateValidator]" (onValueChange)="userProfiledetail.MiddleName = $event">
     
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-6">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Last Name'" [text]="userProfiledetail.LastName"
                        [validators]="[notBlankValidator]" (onValueChange)="userProfiledetail.LastName = $event"
                        maxlength="50" [disabled]="DisabledName">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedCheckbox class="centered-checkbox" [id]="'no-middle-name'" [label]="'No Middle Name'"
                        [checked]="userProfiledetail.isNoMidNameChecked" (onValueChange)="clickOnMiddleName($event)">

                    </ValidatedCheckbox>

                    <!--(click)="clickOnMiddleName()">-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field" [label]="'Email'" id="email" [text]="userProfiledetail.Email"
                        (onValueChange)="userProfiledetail.Email = $event" [validators]="[notBlankValidator]"
                        maxlength="150">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>Business Address</legend>
        <div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Street Address Line 1'" [text]="userProfiledetail.addressLine1"
                            [validators]="[notBlankValidator]" (onValueChange)="userProfiledetail.addressLine1= $event"
                            maxlength="100">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Street Address Line 2 (optional)'"
                            [text]="userProfiledetail.addressLine2"
                            (onValueChange)="userProfiledetail.addressLine2= $event" maxlength="100">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'City'" [text]="userProfiledetail.city"
                            [validators]="[notBlankValidator]" (onValueChange)="userProfiledetail.city = $event"
                            maxlength="50">
                        </ValidatedTextField>
                    </div>
                </div>
                <div class="col-5">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide" [selectedValue]="userProfiledetail.state" [label]="'State'" [for]="'State'"
                            (onValueChange)="userProfiledetail.state = $event" [options]="allStates" [validators]="[notBlankStateValidator]">
                        </ValidatedDropDown>
                    </div>
                </div>
                <div class="col-3">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Zip'" [text]="userProfiledetail.zip"
                            [validators]="[notBlankValidator, zipCodeValidator, numericValidator]"
                            (onValueChange)="userProfiledetail.zip = $event" maxlength="5">
                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <MaskedValidatedTextField class="field" [label]="'Phone Number '" id="authrep-phone"
                            [text]="userProfiledetail.phoneNum" (onValueChange)="userProfiledetail.phoneNum = $event"
                            [maxlength]="10" [inputMask]="phoneNumberInputMask"
                            [validators]="[notBlankValidator, lengthValidator,numericValidator]">
                        </MaskedValidatedTextField>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <div *ngIf="displayProfile">
        <fieldset>
            <legend>Profile Setting</legend>
            <div id="divUserStatus" *ngIf="displayuserstatus">
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <ValidatedDropDown class="wide" [label]="'User Status'" [options]="userprofileStatus"
                                [selectedValue]="userProfiledetail.UserProfileStatusId"
                                (onValueChange)="OnStatusChange($event)">
                            </ValidatedDropDown>
                        </div>
                    </div>
                    <div id="divStatusreason" style="display:none" class="col-4">
                        <div class="input-wrapper">
                            <ValidatedDropDown [label]="'Status Reason'" [options]="statusReason"
                                [selectedValue]="userProfiledetail.UserProfileStatusReason"
                                (onValueChange)="userProfiledetail.UserProfileStatusReason=$event">
                            </ValidatedDropDown>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedCheckbox [id]="'change-password'" class="centered-checkbox"
                            [label]="'Change Password'" [checked]="userProfiledetail.ChangePassword"
                            (onValueChange)="userProfiledetail.ChangePassword= $event">
                        </ValidatedCheckbox>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" id="submitAll" (click)="submitForm()">Save</button>

            <button class="button cancel" id="cancel" (click)="Cancel()">Cancel</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24" id="divEdit" *ngIf="showCommentsLicenseTrainingSection">
            <div class="tabs">
                <!--<button *ngIf="showLicenseTab" (click)="showTabbed(2)" [ngClass]="{'on': licenseScreenShow}" aria-controls="panel-license" id="license" role="tab">License</button>-->
                <button *ngIf="showCommentsTab" (click)="showTabbed(1)" [ngClass]="{'on': commentsScreenShow}"
                    aria-controls="panel-comments" id="comments" role="tab">Comments</button>
                <button *ngIf="showLicenseTab" (click)="showTabbed(2)" [ngClass]="{'on': licenseScreenShow}"
                    aria-controls="panel-license" id="license" role="tab">License</button>
                <button *ngIf="showTrainingTab" (click)="showTabbed(3)" [ngClass]="{'on': trainingScreenShow}"
                    aria-controls="panel-training" id="training" role="tab">Training</button>

            </div>
            <!--<div *ngIf="licenseScreenShow" aria-labelledby="license" aria-live="assertive" id="panel-license" role="tabpanel">
                <License [licenseViewModel]="this.licenseViewModel"></License>

            </div>-->
            <div *ngIf="commentsScreenShow" aria-labelledby="comments" aria-live="assertive" id="panel-comments"
                role="tabpanel">
                <UserComments [commentsViewModel]="this.commentsViewModel"
                    (onCommentAdded)="this.onCommentAdded($event)"></UserComments>
            </div>

            <div *ngIf="licenseScreenShow" aria-labelledby="license" aria-live="assertive" id="panel-license"
                role="tabpanel">
                <License [licenseViewModel]="this.licenseViewModel"></License>

            </div>
            <div *ngIf="trainingScreenShow" aria-labelledby="training" aria-live="assertive" id="panel-training"
                role="tabpanel">
                <UserTraining></UserTraining>
            </div>

        </div>
    </div>
</div>